export const validateRules = async <T>(rules: RuleFunction<T>[], value: T): Promise<string | true> => {
  if (rules.length > 0) {
    for (const rule of rules) {
      const result = await rule(value);
      if (typeof result === "string") {
        return result;
      }
    }
  }
  return true;
};

export const isValidEmail = (val: string) => {
  const emailPattern =
    /^(?=[a-zA-Z0-9@.'_%+-]{6,254}$)[a-zA-Z0-9.'_%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/;
  return emailPattern.test(val);
};
